import { urlsServices } from '@/config/urls';
import { formatarData } from '@/utils/data';
import axios from 'axios';

let httpUrl = `${urlsServices.GETWAY}api/agendamento-medico`;
export const consultarAgendamento = async (obj) => {
  if (obj.dataInicio) {
    obj.dataInicio = formatarData(obj.dataInicio, 'DD/MM/yyyy');
    if (obj.dataFim) {
      obj.dataFim = formatarData(obj.dataFim, 'DD/MM/yyyy');
    }
  }
  return await axios
    .get(`${httpUrl}/search`, {
      params: obj,
    })
    .then((response) => response);
};

export const updateAgendamento = async (obj) => {
  return await axios.post(`${httpUrl}/update-gerenciamento`, obj).then((response) => response);
};

export const getByIdAgendamento = async (id) => {
  return await axios.get(`${httpUrl}/${id}`).then((response) => response);
};

export const getQtdAtendimentos = async () => {
  return await axios.get(`${httpUrl}/count-atendimentos`).then((response) => response);
};

export const excluirAgendamento = async (id) => {
  return await axios.delete(`${httpUrl}/delete/${id}`).then((response) => response);
};

export const getSituacaoAgendamentoRelatorio = async (params) => {
  return await axios.put(`${httpUrl}/relatorio-situacao-agendamentos`, params).then((response) => response);
};
